import {ProposalModel} from '@features/search/interfaces';
import {Proposal} from '@services/user-gw';
import {BasketItemModel} from '@features/basket/interfaces';
import {getLocalDateTime, shouldShowDeliveryRange} from '@utils';

export const createProposal = (
    x: Proposal,
    generation: number,
    b?: BasketItemModel
): ProposalModel => {
    const expectedDays = x.delivery?.expected.client.days;
    const guaranteedDays = x.delivery?.guaranteed.client.days;
    const expectedDate = x.delivery?.expected.client.date;
    const guaranteedDate = x.delivery?.guaranteed.client.date;

    const shouldShowRange = shouldShowDeliveryRange(expectedDate, guaranteedDate);

    return {
        id: `${x.id}`,
        deliveryDate: getLocalDateTime(
            shouldShowRange ? x.delivery?.guaranteed.client.date : x.delivery?.expected.client.date
        ),
        deliveryDays: expectedDays,
        deliveryDaysMax: shouldShowRange ? guaranteedDays : undefined,
        isOfficialDealer: x.flags['official'],
        isReturnPossible: x.returnCondition !== 'impossible',
        multiplicity: x.multiplicity === 0 ? 1 : x.multiplicity,
        price: x.price,
        quantity: x.quantity,
        rating: x.rating || 0,
        generation: generation,
        basketItem: b,
        priceList: x.priceList,
        isBanned: x.isBanned,
        isFavorite: x.isFavorite
    };
};
